import styled from 'styled-components';

/** Card contenitore standard: sfondo bianco, bordo e ombra sobri. */
export const Card = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--gray-200);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  padding: var(--space-md) var(--space-lg);
  border-bottom: 1px solid var(--gray-100);
  background: var(--gray-50);

  h2,
  h3 {
    margin: 0;
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-semibold);
    color: var(--text-primary);
  }
`;

export const CardBody = styled.div`
  padding: var(--space-lg);
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-lg);
  border-top: 1px solid var(--gray-100);
  background: var(--gray-50);
`;

export default Card;
